import { Col, Divider, Image, Row } from 'antd';
import CommonFormAnt from 'commons/Forms/CommonFormAnt';
import {
    commonElement,
    commonInput,
    commonInputRows
} from 'commons/Forms/formsComponents/formTypes';
import { AuthContext } from 'context/auth';
import React, { useContext } from 'react';
import ServiceUser from 'services/user';
//import { ReactComponent as Logo } from 'images/logo-pc.svg';
import logoImg from 'images/logo.png';
import { Link, Route, Routes } from 'react-router-dom';
import SignupForm from './signup';
import ServiceAuth from 'services/auth';


const formFields: Array<commonInput | commonInputRows | commonElement> = [
    {
        type: 'string', // "email",
        name: 'username',
        label: 'Email',
        placeholder: 'Username',
    },
    {
        type: 'password',
        name: 'password',
        label: 'Password',
        placeholder: 'Password',
    },
];

const LoginForm = (props) => {
    const { authenticate } = useContext(AuthContext);

    const doLogin = async (data) => {

        ServiceAuth.login(data)
            .then(async (response) => {
                const { token } = response;
                authenticate({ token: token })
            });
    };

    return (
        <Row justify="space-around" align="middle">
            <Col span={8} style={{ margin: '6% auto', textAlign: 'center' }}>
                <Image preview={false} src={logoImg} />
                <section className="appLogin">
                    <h1><strong>CREA - LOGIN</strong></h1>
                    <h3 dangerouslySetInnerHTML={{
                        __html: "Sistema progettazione aree verdi"
                    }} />
                    <Divider />
                    <CommonFormAnt
                        autocomplete={true}
                        fields={formFields}
                        onSubmit={(data) => doLogin(data)}
                        submitText="Entra"
                        submitOnEnterKey
                    />
                </section>
                <p className="additional-info">
                    Password dimenticata? <Link to="/reset-password">Reset password</Link>
                </p>
                <p className="additional-info">
                    Crea un account <Link to="/signup">Registrati</Link>
                </p>
            </Col>
        </Row>

    );
};

export default LoginForm;
